export default {
  logs: 'Logi',
}
